module.exports = __webpack_public_path__ + "static/img/zhinengbanner.5053a32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhinengbanner.jpg
// module id = dCg/
// module chunks = 0